// Lightweight analytics helpers for GA4 (loaded via gtag) and GTM.
//
// All calls go through window.gtag, which is bootstrapped synchronously in
// public/index.html before the gtag/js script loads. Events fired before the
// script finishes loading are queued in window.dataLayer and replayed when
// the script initialises, so we don't lose early route changes.

export function trackEvent(name, params = {}) {
  if (!name || typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

export function trackPageView(pagePath, pageTitle) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
    page_location: window.location.href,
  });
}
